import axios, { AxiosInstance } from 'axios'
import { useMemo } from 'react'

import { config } from '../configs/api.config'

import { configureClient } from './api-utils'

// Temporary placeholder until `@epilot/compliance-client-internal` is
// generated at the end of D1 against the real `openapi.yml`. Swap this file
// to follow the `pricing-tier-client.ts` pattern (getClient from the SDK)
// once the SDK exists.

export type ComplianceHealth = {
  status: 'ok'
  commit: string
  stage: 'local' | 'dev' | 'staging' | 'prod'
}

let client: AxiosInstance

export const getComplianceClient = () => {
  if (!client) {
    client = axios.create({ baseURL: config.COMPLIANCE })
    configureClient(client, { baseURL: config.COMPLIANCE })
  }

  return client
}

export const useComplianceClient = () =>
  useMemo(() => getComplianceClient(), [])

export const fetchComplianceHealth = async (): Promise<ComplianceHealth> => {
  const { data } = await getComplianceClient().get<ComplianceHealth>(
    '/v1/internal/health'
  )

  return data
}
